module.exports = __webpack_public_path__ + "img/auth-floor.bfff9159.jpg";